import { render, staticRenderFns } from "./InfoCarriesQuote.vue?vue&type=template&id=7447c656&scoped=true"
import script from "./InfoCarriesQuote.vue?vue&type=script&lang=js"
export * from "./InfoCarriesQuote.vue?vue&type=script&lang=js"
import style0 from "./InfoCarriesQuote.vue?vue&type=style&index=0&id=7447c656&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7447c656",
  null
  
)

export default component.exports